export default "__VITE_ASSET__8462bf95__"